var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "layer-1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "252.99 246.08 246.4 371.55 162.91 367.17 163.61 353.87 169.5 241.69 222.07 244.45 252.99 246.08",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.51 336.04 116.96 358.43 83.32 237.36 116.67 228.09 163.87 214.98 194.39 324.82 197.51 336.04",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75H407a5.08,5.08,0,0,1,5.43,4.71A5.15,5.15,0,0,1,412.16,275.05Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.15,363v8.24H287.23V363a6.06,6.06,0,0,1,6.06-6.06h77.79a6.05,6.05,0,0,1,6.07,6.06Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.31,369c-4.31,4.39,16.58,73.37,16.58,73.37-2.28,2-5.64,2.92-8.82,3.34a40.55,40.55,0,0,1-8.81.13s-29.94-72.62-21.7-90.64S320.93,329,320.93,329l2.18-5.4,26.45-3.72,4.37,32.39s-4.34.42-10.87,1.26C325.55,355.75,292.23,361,284.31,369Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.36,277.39a18.39,18.39,0,0,1-1-7.43,21.83,21.83,0,0,1,.27-2.55l-1.69-2.68-2.17-3.45,2.51-10s16,3.08,17.2,7.54S324.36,277.39,324.36,277.39Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.33,259.88c-.05-76.49,11.45-96.74-30-161.36s-143.06-78.93-219.9-31-97.5,109.57-97.5,109.57-27.88,72,11.3,144.5c35.83,66.32,106.39,104,167.59,135H403.31a110.3,110.3,0,0,0,23.92-28.3C459.1,374.66,415.39,336.37,415.33,259.88Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.33,259.88c-.05-76.49,11.45-96.74-30-161.36s-143.06-78.93-219.9-31-97.5,109.57-97.5,109.57-27.88,72,11.3,144.5c35.83,66.32,106.39,104,167.59,135H403.31a110.3,110.3,0,0,0,23.92-28.3C459.1,374.66,415.39,336.37,415.33,259.88Z",
    style: {
      fill: "#fff",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clocks--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.79,50.72c1.35,5.35.69-4.5,3.34-16.56S240.31,27,240.31,27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.96,
    y1: 38.4,
    x2: 237.27,
    y2: 35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.14,30.92s-5,10.26,2.51,14.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.18,28s8.19,4.55,3.06,14.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.56,
    y1: 34.39,
    x2: 251.43,
    y2: 38.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.17,
    y1: 32.51,
    x2: 245.57,
    y2: 39.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,292.42s-13.93-.2-14,11.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.15,300c-.29-1.77-6.35-4-7.4.62s6.48,1.85,8.81-.31c0,0-4.32,4.2-3,5.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,307s-1.83,2.29-3.81,1.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.19,299,72.74,309.61S78,304.28,81.05,306c3.8,2.08-1.13,7.78-5.19,3.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47,301.86S91.24,314.55,76.94,315",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "275.03 86.13 280.07 86.96 280.14 98.41 291.18 78.28 308.6 81.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.09,
    y1: 87.1,
    x2: 300.75,
    y2: 100.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.72,
    y1: 88.68,
    x2: 289.01,
    y2: 98.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.16,106.51c-1.29-1.64-8.72-.47-7.21,4.79s7.65-1.75,8.82-5.26c0,0-2.05,6.71,0,7.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,101.1l-1.66,5.9s.83-3,2.29-3c1.79,0,1.14,3-1.15,2.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "351.93 173.82 348.43 186.47 356.08 194.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.31,
    y1: 178.96,
    x2: 365.07,
    y2: 186.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.34,
    y1: 177.16,
    x2: 358.55,
    y2: 186.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.5,185.27s.08,2.64-1.06,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.61,
    y1: 176.05,
    x2: 374.9,
    y2: 179.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.86,
    y1: 172.82,
    x2: 371.64,
    y2: 191.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "377.12 166.29 385.6 175.89 381.99 186.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.58 414.01 155.85 377.49 170.73 394.1 143.58 414.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.08 396.77 163.94 393.18 167.29 390.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.28,
    cy: 197.29,
    r: 12.49,
    transform: "translate(-70.46 40.38) rotate(-22.5)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.13,
    cy: 186.35,
    r: 13.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.73,
    y1: 185.04,
    x2: 67.04,
    y2: 190.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.12,
    y1: 185.77,
    x2: 68.73,
    y2: 194.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.63,
    y1: 187.19,
    x2: 71.12,
    y2: 196.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.42,
    y1: 190,
    x2: 74.63,
    y2: 199.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.99,
    y1: 192.96,
    x2: 76.42,
    y2: 199.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,181.28c-1.09-.33-4.08,2.51-1.76,4.42s2.91-3.18,2.34-5.13c0,0,1.17,3.67,2.23,3.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.45,165.25l4,7.28s-2-3.64-.59-5c1.72-1.68,4,1.87,1.12,3.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.54,
    y1: 164.38,
    x2: 149.19,
    y2: 169.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.19,
    y1: 162.99,
    x2: 144.46,
    y2: 170.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.75,
    y1: 165.02,
    x2: 160.4,
    y2: 162.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.11,
    y1: 157.02,
    x2: 166.55,
    y2: 160.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.18,
    y1: 153.36,
    x2: 164.83,
    y2: 168.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.14,150.36l-.24-11.42h8.63s-4.78,2.64-2.58,8.78,5.74,2.64,5.74,2.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.52 345.17 411.34 338.41 424.34 339.32 425.15 355.8 415.61 362.63 403.83 361.77 401.52 345.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "403.83 361.77 413.33 354.93 425.15 355.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.34,
    y1: 354.93,
    x2: 411.34,
    y2: 338.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "401.52 345.17 414.49 346.67 424.34 339.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.49,
    y1: 346.67,
    x2: 415.61,
    y2: 362.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.31 221.39 402.89 243.36 422.14 234.62 403.31 221.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.31,
    y1: 221.39,
    x2: 412.48,
    y2: 238.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "411.01 236.07 413.24 234.99 414.74 237.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.47,
    y1: 219.31,
    x2: 243.43,
    y2: 227.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.49,
    y1: 218.16,
    x2: 236.8,
    y2: 227.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.75,213.69a1.59,1.59,0,0,1,2.11.77,1.64,1.64,0,0,1,.13.43c.39,1.92-2.76,4.42-2.76,4.42h4.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54,91.5a28.92,28.92,0,0,1,15.24-23.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65,122A28.92,28.92,0,0,1,116,109.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.3,96.11a29,29,0,0,1-31.19,26.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,64.93a29,29,0,0,1,26.41,24.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.92,116.11a25.57,25.57,0,0,1-38-24.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,84.61a25.57,25.57,0,1,1,42.93,26.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "137.91 75.41 140.42 93.81 154.56 89.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.9,129.57a20.06,20.06,0,0,1-13.69-34.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.69,116a20,20,0,0,1-12.32,12.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.05,90.59a20.06,20.06,0,0,1,25.58,12.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.61,94.84a17.7,17.7,0,1,1-23,26.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,115.38a17.7,17.7,0,0,1,21.15-23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "353.95 98.58 360.71 109.51 354.55 117.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,408.43a16.06,16.06,0,0,1,7-13.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.71,419.51a16.09,16.09,0,0,1-26.89-5.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.05,392.34a16.09,16.09,0,0,1,16.09,16.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.05,422.62a14.19,14.19,0,0,1-14.19-14.19h0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,399.52a14.2,14.2,0,1,1,18,21.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "232.85 418.07 235.05 408.43 231.98 400.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.71,
    y1: 456.95,
    x2: 452.29,
    y2: 456.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exam-sheets--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "252.99 246.08 246.4 371.55 162.91 367.17 163.61 353.87 169.5 241.69 222.07 244.45 252.99 246.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.93 319.59 208.12 321.14 213.61 344.83 163.61 353.87 169.5 241.69 222.07 244.45 226.93 319.59",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "252.99 246.08 246.4 371.55 162.91 367.17 163.61 353.87 169.5 241.69 222.07 244.45 252.99 246.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.39,
    y1: 250.27,
    x2: 197.12,
    y2: 251.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.17,
    y1: 254.44,
    x2: 189.95,
    y2: 255.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.95,
    y1: 264.57,
    x2: 242.45,
    y2: 267.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.73,
    y1: 268.74,
    x2: 242.23,
    y2: 272.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.48,
    y1: 273.61,
    x2: 232.78,
    y2: 276.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.36,
    y: 278.19,
    width: 5.09,
    height: 5.09,
    transform: "translate(-107.99 447.64) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.58,
    y: 278.67,
    width: 5.09,
    height: 5.09,
    transform: "translate(-99.74 457.31) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.78,
    y: 279.16,
    width: 5.09,
    height: 5.09,
    transform: "translate(-91.51 466.96) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.99,
    y: 279.64,
    width: 5.09,
    height: 5.09,
    transform: "translate(-83.26 476.62) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,264.39a1.26,1.26,0,0,1-1.31,1.21h0a1.27,1.27,0,1,1,.13-2.54,1.26,1.26,0,0,1,1.2,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.67,
    y1: 288.9,
    x2: 241.17,
    y2: 292.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.45,
    y1: 293.07,
    x2: 240.95,
    y2: 296.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.2,
    y1: 297.94,
    x2: 231.5,
    y2: 300.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.08,
    y: 302.52,
    width: 5.09,
    height: 5.09,
    transform: "translate(-133.51 469.43) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.29,
    y: 303,
    width: 5.09,
    height: 5.09,
    transform: "translate(-125.25 479.08) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.5,
    y: 303.49,
    width: 5.09,
    height: 5.09,
    transform: "translate(-117.02 488.73) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 303.97,
    width: 5.09,
    height: 5.09,
    transform: "translate(-108.78 498.39) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,288.72a1.27,1.27,0,0,1-1.33,1.21h0a1.28,1.28,0,1,1,1.34-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.4,
    y1: 313.23,
    x2: 239.89,
    y2: 316.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.18,
    y1: 317.4,
    x2: 239.67,
    y2: 320.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.92,
    y1: 322.26,
    x2: 230.22,
    y2: 325.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.81,
    y: 326.84,
    width: 5.09,
    height: 5.09,
    transform: "translate(-159 491.2) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.1,
    y: 327.31,
    width: 5.1,
    height: 5.1,
    transform: "translate(-149.26 502.8) rotate(-87.14)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0012492197622458px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.22,
    y: 327.82,
    width: 5.09,
    height: 5.09,
    transform: "translate(-142.53 510.51) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.44,
    y: 328.29,
    width: 5.09,
    height: 5.09,
    transform: "translate(-134.26 520.17) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,313.05a1.27,1.27,0,0,1-1.33,1.21h0a1.28,1.28,0,1,1,0-2.56h.18a1.27,1.27,0,0,1,1.21,1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.08,
    y1: 338.25,
    x2: 238.57,
    y2: 341.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.86,
    y1: 342.42,
    x2: 238.36,
    y2: 345.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.61,
    y1: 347.29,
    x2: 228.91,
    y2: 350.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.47,
    y: 351.87,
    width: 5.09,
    height: 5.09,
    transform: "translate(-185.25 513.58) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 352.35,
    width: 5.09,
    height: 5.09,
    transform: "translate(-176.99 523.26) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.92,
    y: 352.84,
    width: 5.09,
    height: 5.09,
    transform: "translate(-168.74 532.91) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.13,
    y: 353.33,
    width: 5.09,
    height: 5.09,
    transform: "translate(-160.51 542.58) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.75,338.08a1.27,1.27,0,1,1-1.2-1.34,1.27,1.27,0,0,1,1.2,1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "181.23 280.17 181.89 281.31 184.6 278.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "198.39 305.16 199.05 306.3 201.76 303.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "207 330.84 207.66 331.98 210.37 328.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "186.6 353.76 187.26 354.89 189.97 351.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.51 336.04 116.96 358.43 83.32 237.36 116.67 228.09 163.87 214.98 194.39 324.82 197.51 336.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 324.82 132.11 328.85 116.67 228.09 163.87 214.98 194.39 324.82",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "197.51 336.04 116.96 358.43 83.32 237.36 116.67 228.09 163.87 214.98 194.39 324.82 197.51 336.04",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.64,
    y1: 243.62,
    x2: 112.6,
    y2: 237.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.75,
    y1: 247.65,
    x2: 107.01,
    y2: 243.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    y1: 255.73,
    x2: 160.8,
    y2: 238.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.62,
    y1: 259.75,
    x2: 161.92,
    y2: 243,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.92,
    y1: 264.45,
    x2: 154.35,
    y2: 250.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 267.88,
    width: 5.09,
    height: 5.09,
    transform: "translate(-68.48 38.66) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 265.4,
    width: 5.09,
    height: 5.09,
    transform: "translate(-67.49 40.95) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.75,
    y: 262.93,
    width: 5.09,
    height: 5.09,
    transform: "translate(-66.51 43.24) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.62,
    y: 260.47,
    width: 5.09,
    height: 5.09,
    transform: "translate(-65.52 45.52) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.29,256.62a1.27,1.27,0,0,1-2.45.68,1.27,1.27,0,0,1,2.45-.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.02,
    y1: 279.2,
    x2: 167.32,
    y2: 262.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.14,
    y1: 283.23,
    x2: 168.44,
    y2: 266.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.45,
    y1: 287.92,
    x2: 160.87,
    y2: 273.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.49,
    y: 291.35,
    width: 5.09,
    height: 5.09,
    transform: "translate(-74.53 41.26) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.37,
    y: 288.88,
    width: 5.09,
    height: 5.09,
    transform: "translate(-73.54 43.55) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.26,
    y: 286.41,
    width: 5.09,
    height: 5.09,
    transform: "translate(-72.55 45.84) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.16,
    y: 283.93,
    width: 5.09,
    height: 5.09,
    transform: "translate(-71.56 48.13) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82,280.1a1.28,1.28,0,1,1-1.58-.89h0a1.27,1.27,0,0,1,1.57.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.55,
    y1: 302.68,
    x2: 173.84,
    y2: 285.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.67,
    y1: 306.7,
    x2: 174.96,
    y2: 289.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.97,
    y1: 311.4,
    x2: 167.4,
    y2: 297.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 314.82,
    width: 5.09,
    height: 5.09,
    transform: "translate(-80.57 43.86) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.9,
    y: 312.35,
    width: 5.09,
    height: 5.09,
    transform: "translate(-79.58 46.15) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.78,
    y: 309.88,
    width: 5.09,
    height: 5.09,
    transform: "translate(-78.6 48.44) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.67,
    y: 307.41,
    width: 5.09,
    height: 5.09,
    transform: "translate(-77.61 50.73) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,303.57a1.28,1.28,0,1,1-1.58-.89h0a1.27,1.27,0,0,1,1.57.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.26,
    y1: 326.82,
    x2: 180.55,
    y2: 310.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.37,
    y1: 330.85,
    x2: 181.67,
    y2: 314.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.68,
    y1: 335.54,
    x2: 174.11,
    y2: 321.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.71,
    y: 338.97,
    width: 5.09,
    height: 5.09,
    transform: "translate(-86.79 46.54) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.61,
    y: 336.5,
    width: 5.09,
    height: 5.09,
    transform: "translate(-85.81 48.83) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.5,
    y: 334.03,
    width: 5.09,
    height: 5.09,
    transform: "translate(-84.82 51.12) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.38,
    y: 331.56,
    width: 5.09,
    height: 5.09,
    transform: "translate(-83.83 53.41) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,327.71a1.28,1.28,0,0,1-2.46.71,1.29,1.29,0,0,1,.88-1.59h0a1.28,1.28,0,0,1,1.57.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "115.04 267.78 116.03 268.65 117.65 264.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "112.63 293.97 113.62 294.84 115.23 291.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.15 317.2 120.14 318.07 121.75 314.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "143.62 336.23 144.61 337.1 146.23 333.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.98,
    y: 190.72,
    width: 83.6,
    height: 125.65,
    transform: "translate(-23.48 17.41) rotate(-5.49)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.25,
    y1: 202.64,
    x2: 150.91,
    y2: 200.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.65,
    y1: 206.8,
    x2: 144.38,
    y2: 205.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.87,
    y1: 216.11,
    x2: 198.16,
    y2: 210.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.27,
    y1: 220.26,
    x2: 198.56,
    y2: 214.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.74,
    y1: 225.11,
    x2: 189.87,
    y2: 220.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.67,
    y: 229.24,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.53 14.48) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 228.36,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.41 15.35) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 227.48,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.28 16.23) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.22,
    y: 226.59,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.15 17.1) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,216.43a1.28,1.28,0,1,1-1.4-1.15h0a1.27,1.27,0,0,1,1.39,1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2,
    y1: 240.36,
    x2: 200.49,
    y2: 234.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.6,
    y1: 244.52,
    x2: 200.89,
    y2: 238.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.07,
    y1: 249.37,
    x2: 192.2,
    y2: 244.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 253.49,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.84 14.81) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.19,
    y: 252.61,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.72 15.69) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.37,
    y: 251.73,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.59 16.56) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.55,
    y: 250.86,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.46 17.44) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,240.68a1.28,1.28,0,1,1-1.4-1.15h0A1.28,1.28,0,0,1,134.89,240.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.53,
    y1: 264.61,
    x2: 202.82,
    y2: 258.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.93,
    y1: 268.77,
    x2: 203.22,
    y2: 262.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.4,
    y1: 273.62,
    x2: 194.53,
    y2: 268.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.33,
    y: 277.74,
    width: 5.09,
    height: 5.09,
    transform: "translate(-26.15 15.15) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.51,
    y: 276.86,
    width: 5.09,
    height: 5.09,
    transform: "translate(-26.02 16.02) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 275.98,
    width: 5.09,
    height: 5.09,
    transform: "translate(-25.9 16.9) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.88,
    y: 275.1,
    width: 5.09,
    height: 5.09,
    transform: "translate(-25.77 17.77) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,264.93a1.27,1.27,0,1,1-1.38-1.15,1.27,1.27,0,0,1,1.38,1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.93,
    y1: 289.56,
    x2: 205.22,
    y2: 283.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.33,
    y1: 293.71,
    x2: 205.62,
    y2: 287.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.79,
    y1: 298.56,
    x2: 196.92,
    y2: 293.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.73,
    y: 302.69,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.53 15.49) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.92,
    y: 301.81,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.4 16.37) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.09,
    y: 300.92,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.27 17.24) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.28,
    y: 300.04,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.15 18.11) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61,289.87a1.28,1.28,0,1,1-1.39-1.14,1.27,1.27,0,0,1,1.39,1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.44 231.35 140.26 232.38 142.5 229.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.11 253.53 160.93 254.56 163.16 251.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "153.3 279.17 154.12 280.2 156.36 276.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "173.93 302.16 174.75 303.19 176.99 299.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.15,137.71H255.48a6.88,6.88,0,0,0-6.88,6.88h0V189a6.88,6.88,0,0,0,6.88,6.88h22.9l13.12,15.81-3.29-15.81h18.94A6.88,6.88,0,0,0,314,189V144.59A6.88,6.88,0,0,0,307.15,137.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.45,162.07v-4.7l-3.52-.3a10.2,10.2,0,0,0-.87-2.11l2.27-2.7L280,148.94l-2.7,2.27a9.48,9.48,0,0,0-2.11-.87l-.3-3.52h-4.7l-.3,3.52a9.48,9.48,0,0,0-2.11.87l-2.7-2.27-3.33,3.32L264,155a10,10,0,0,0-.88,2.11l-3.52.3v4.7l3.52.31a10,10,0,0,0,.88,2.11l-2.28,2.7,3.33,3.32,2.7-2.27a9.48,9.48,0,0,0,2.11.87l.3,3.52h4.7l.3-3.52a9.48,9.48,0,0,0,2.11-.87l2.7,2.27,3.33-3.32-2.27-2.7a10.2,10.2,0,0,0,.87-2.11Zm-12.91,3.12a5.47,5.47,0,1,1,5.46-5.48h0a5.45,5.45,0,0,1-5.45,5.47Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,172.56v-3.34l-2.51-.22a6.78,6.78,0,0,0-.62-1.5l1.62-1.92-2.36-2.36-1.93,1.61a7.29,7.29,0,0,0-1.5-.62l-.21-2.5h-3.35l-.21,2.5a7.38,7.38,0,0,0-1.51.62l-1.92-1.61-2.36,2.36,1.61,1.92a6.75,6.75,0,0,0-.61,1.5l-2.51.22v3.34l2.51.22a6.75,6.75,0,0,0,.61,1.5l-1.61,1.92,2.36,2.37,1.92-1.62a6.4,6.4,0,0,0,1.51.62l.21,2.51h3.35l.21-2.51a6.33,6.33,0,0,0,1.5-.62l1.93,1.62,2.36-2.37-1.62-1.92a6.33,6.33,0,0,0,.62-1.5Zm-9.19,2.22a3.89,3.89,0,1,1,3.89-3.89,3.89,3.89,0,0,1-3.89,3.89Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.64,180.35V178l-1.79-.16a4.73,4.73,0,0,0-.44-1.07l1.15-1.36-1.68-1.69-1.37,1.15a5.78,5.78,0,0,0-1.06-.44l-.16-1.78h-2.38l-.15,1.78a5.24,5.24,0,0,0-1.07.44l-1.37-1.15-1.68,1.69,1.15,1.36a5.24,5.24,0,0,0-.44,1.07l-1.78.16v2.37l1.78.16a5.24,5.24,0,0,0,.44,1.07L272.64,183l1.68,1.69,1.37-1.15a5.87,5.87,0,0,0,1.07.44l.15,1.78h2.38l.16-1.78a5.78,5.78,0,0,0,1.06-.44l1.37,1.15,1.68-1.69-1.15-1.36a4.73,4.73,0,0,0,.44-1.07Zm-6.54,1.58a2.77,2.77,0,1,1,2.77-2.77h0a2.77,2.77,0,0,1-2.77,2.76Z",
    style: {
      fill: "#FFC100"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "279.93 308.37 320.21 456.95 326.23 456.95 285.96 308.37 279.93 308.37",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.3,
    y: 414.83,
    width: 76.35,
    height: 6.22,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,275,362.05,457h-6l49.32-182c1.82-6.71-2.35-12.17-9.3-12.17h-42.5c-6.94,0-14.08,5.46-15.9,12.17L288.33,457h-6l49.33-182c2.69-9.93,13.21-18,23.49-18h42.51C407.91,257,414.07,265.06,411.38,275Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75H407a5.08,5.08,0,0,1,5.43,4.71A5.15,5.15,0,0,1,412.16,275.05Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75h36.11c15.61,16,13.62,45.49,12.6,54.39a9.74,9.74,0,0,0,7-6.52L405.1,271a6.11,6.11,0,0,0,.15-2.69H407a5.08,5.08,0,0,1,5.16,6.74Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75H407a5.08,5.08,0,0,1,5.43,4.71A5.15,5.15,0,0,1,412.16,275.05Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.1 372.71 393.94 456.95 399.96 456.95 377.13 372.71 371.1 372.71",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.15,363v8.24H287.23V363a6.06,6.06,0,0,1,6.06-6.06h77.79a6.05,6.05,0,0,1,6.07,6.06Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.94,361.45c-2.91,3.42-8.13,6.9-17.11,9.83h-72.6V363a6.06,6.06,0,0,1,6.06-6.06h77.79A6.07,6.07,0,0,1,376.94,361.45Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.15,363v8.24H287.23V363a6.06,6.06,0,0,1,6.06-6.06h77.79a6.05,6.05,0,0,1,6.07,6.06Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.25,
    y: 368.75,
    width: 98.66,
    height: 7.73,
    rx: 1.71,
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.31,369c-4.31,4.39,16.58,73.37,16.58,73.37-2.28,2-5.64,2.92-8.82,3.34a40.55,40.55,0,0,1-8.81.13s-29.94-72.62-21.7-90.64S320.93,329,320.93,329l2.18-5.4,26.45-3.72,4.37,32.39s-4.34.42-10.87,1.26C325.55,355.75,292.23,361,284.31,369Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.89,442.41c-2.28,2-5.64,2.92-8.82,3.34-5.81-21.6-20.6-79.24-15-86.29,6.91-8.7,41.11-16.61,41.11-16.61.14-4.44,12.13-8.44,12.13-8.44l12.74,19.09C325.54,355.75,292.22,361,284.3,369,280,373.43,300.89,442.41,300.89,442.41Z",
    style: {
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.31,369c-4.31,4.39,16.58,73.37,16.58,73.37-2.28,2-5.64,2.92-8.82,3.34a40.55,40.55,0,0,1-8.81.13s-29.94-72.62-21.7-90.64S320.93,329,320.93,329l2.18-5.4,26.45-3.72,4.37,32.39s-4.34.42-10.87,1.26C325.55,355.75,292.23,361,284.31,369Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,292.19s6.55,1.63,8.56,3,1.43,6.32,1.43,6.32S276.26,299.05,275,292.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.82 279.64 283 303 284.44 303 272.87 278.49 270.82 279.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.8,296.53s-7.68-5.46-9.56-5.46-7.51,6.65-7.51,10,12.28,5.18,14.68,2.35c1.2-1.41-1.18-4.81-1.18-4.81a45,45,0,0,0,4.59,4.25c1,.56,2.91-.17,2.91-.17S283.17,298.59,281.8,296.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,304.19a23.06,23.06,0,0,0-6.41-5.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,298.59s-2.66-2.32-4.45-2.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.86,301.54a47.09,47.09,0,0,1,5.37,3.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,263.58c-3.93,2.74-21.58,20.89-21.58,20.89s8.27,9.41,15.52,10.77l19.65-9.54Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,263.58c-3.93,2.74-21.58,20.89-21.58,20.89s8.27,9.41,15.52,10.77l19.65-9.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.51,445.57s1.78,8.51,0,14.84c0,0-26.51,4.15-32.44,2.57s-9.53-4.54-9.71-6c0,0,.21-4.06,6.15-5.25s17.75-2,22.42-8.7S293.51,445.57,293.51,445.57Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.49,322.72c8.47-12.08,47.41,2.46,47.41,2.46s3.71,29.08-11.8,36.84-37.87,7.34-43.91,13.63l-24.58,72.58s-8.83,3.69-21.67-2.12c0,0,15.61-54.81,20.19-74.27,4.53-19.26,33.86-32.33,33.86-32.33a17.81,17.81,0,0,1-3.37-6.08",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.91,350.52A43,43,0,0,1,364,353.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,325.89c3.18,6.9,3.43,15.66-1,22.05",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,327s-.81,5.32,1.56,7.43,9.64,3.18,9.64,3.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.31,327.24s.33,5.3-1.82,5.05-2.26,2.12-2.26,2.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68,267.66a18.1,18.1,0,0,1-.52-4.08s12-10.12,27.45-10.06c18.4.06,29.65,5.85,34.15,13.89,7.14,12.72,8.14,57.77,8.14,57.77s-46.17,7.12-52.79-1.61c-1.15-1.52-.27-12.25-.27-12.25s-5.17-13.56-6.26-24.08a76.45,76.45,0,0,1-4.23-6.5,61,61,0,0,1-4.26-8.61",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.68,267.66a18.1,18.1,0,0,1-.52-4.08s12-10.12,27.45-10.06c18.4.06,29.65,5.85,34.15,13.89,7.14,12.72,8.14,57.77,8.14,57.77s-46.17,7.12-52.79-1.61c-1.15-1.52-.27-12.25-.27-12.25s-5.17-13.56-6.26-24.08a76.45,76.45,0,0,1-4.23-6.5,61,61,0,0,1-4.26-8.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,278.49s7.05,27.35,6,33.37a11,11,0,0,0,1,6.07,6.36,6.36,0,0,0-1,7.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.06,301.12a7,7,0,0,1-3.54-1.12l-2.09-9.16a38.74,38.74,0,0,0,12.38-.87l2.24,10a33.5,33.5,0,0,1-3.83.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.35,282.05s-6-25.56,9.14-28.53,18.25,4.1,17.36,8.89c-1.19,6.39-13.74,22.06-13.74,22.06l-7.75-6Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.35,282.05s-6-25.56,9.14-28.53,18.25,4.1,17.36,8.89c-1.19,6.39-13.74,22.06-13.74,22.06l-7.75-6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.49,361s9.78-11.29,31.86-19.82c0,0-5.72-1.75-7-4.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.99,
    y1: 395.55,
    x2: 279.05,
    y2: 428.01,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,302s4,6.75,20.47,6.13a25.51,25.51,0,0,0-11.24-7C359.57,299.33,357.07,302,357.07,302Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,304.71s3.82-5.92,7.32-7.11,13.78-1.29,15.37-1.33,29.84,7.14,43.1,11.56L357.8,285.7l17.82,1.41s-.72,27-3.49,34.15-6.74,5.41-13.51,2.49c-26.63-11.47-42.23-19.46-43.68-19S293.17,304.71,293.17,304.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.35,272.84a16.62,16.62,0,0,0-.44,5.62c.79,6.92,4.16,23.54,4.16,23.54s16.61,2.37,20.47,6.13c0,0,2.74-22-2.84-33.17s-11.35-12.4-11.35-12.4c-3.65-.9-7,2.5-8.85,6.87",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4000000059604645
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.35,272.84a16.62,16.62,0,0,0-.44,5.62c.79,6.92,4.16,23.54,4.16,23.54s16.61,2.37,20.47,6.13c0,0,2.74-22-2.84-33.17s-11.35-12.4-11.35-12.4c-3.65-.9-7,2.5-8.85,6.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.55,281.4a22.08,22.08,0,0,0,8.5,4.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,281.4s6,11.34,13.58,13.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,368.75s1.11.84,1.56,3.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.08,372.62a7,7,0,0,1,4.89,2.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,361s3.2,1.62,2.51,6.21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.63,364.9s4.37,2.59,4.68,4.91",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.28,336.92s9.73,1.36,11.91,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,277.39a18.39,18.39,0,0,1-1-7.43,21.83,21.83,0,0,1,.27-2.55l-1.69-2.68-2.17-3.45,2.51-10s16,3.08,17.2,7.54S324.36,277.39,324.36,277.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.34,270a21.83,21.83,0,0,1,.27-2.55l-1.69-2.68a12.79,12.79,0,0,0,7.81-4.38A9.83,9.83,0,0,1,323.34,270Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,277.39a18.39,18.39,0,0,1-1-7.43,21.83,21.83,0,0,1,.27-2.55l-1.69-2.68-2.17-3.45,2.51-10s16,3.08,17.2,7.54S324.36,277.39,324.36,277.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,252.12c5-13,1.68-35.13-22.32-30.89C298,223.73,296.3,240.75,301,248.31s-.29,7.8,6.78,13.4c2.87,2.27,5.18,6.12,8.6,6.37,4.07.28,9.28-3.57,13.17-7.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.75,248.31s3.54-3.22,7.75-1.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.12,248.31a6.24,6.24,0,0,0-4.59-3.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.46,253s-.51,2.59-1.18,5.21,4.2,1.19,4,.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.79,262.27a10.63,10.63,0,0,0,5.27-3.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68,251.6a1.1,1.1,0,0,1-.42,1.5,1.11,1.11,0,0,1-1.5-.43,1,1,0,0,1-.14-.51,1.1,1.1,0,0,1,.42-1.5,1.11,1.11,0,0,1,1.5.43A1,1,0,0,1,315.68,251.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,251.38c.2.72.06,1.4-.32,1.5s-.85-.4-1-1.13-.05-1.4.33-1.5S304.78,250.65,305,251.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,234.92s-3.72,9.73-12.92,9.51c0,0,3.19-2.43,4.07-4.75,0,0-7.08,7-14.15,3.44S293,223,303.85,216.46s21.95-4.79,25.71,1.46c0,0,7.6-.7,10.95,10.47,3,10-1.8,25.16-6.49,25.33-7.27.27-8.73-7.62-8.73-7.62A20.81,20.81,0,0,1,319.6,234.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.57,252.17s-.23-9.18,5-8.07,1.44,11.72-2.49,11.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.16,
    y: 303.71,
    width: 83.89,
    height: 6.07,
    rx: 1.63,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.79 425.86 77.78 425.86 81.34 456.95 108.23 456.95 111.79 425.86",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,404.22s-14.85,1.17-15.47,12.13C100.35,416.35,115.39,423.27,115.82,404.22Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.44,406.94s-8.3-11.22-21.71-5.47C64.73,401.47,72.92,415,86.44,406.94Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.87,371.52s-2.39,21.58,17.26,15.64C83.13,387.16,76.89,371.29,65.87,371.52Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,359.5s-15.54,8.38-4.11,21.1C85.88,380.6,96.77,371.51,90,359.5Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,378.79s-16.9-1.71-16.9,13.93C92.21,392.72,109.11,393.39,109.11,378.79Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,438.67s7.7-16.16.31-32.62-9.9-30.33-6-40.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.56,383S93.43,387,90,397.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,380.15s5.85,8,15.76,7.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,403.77s16.2,4.66,22.64,3.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,409.15s-7.25,8-14.53,7.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.32,
    y: 425.17,
    width: 36.93,
    height: 4.39,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,387.36s0-4.31,6.53-4.9,7.46,5.7,7.46,5.7h-2.25s.05-3.77-4.75-4.06-4.62,4.06-4.62,4.06Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.27,391.93c5,1.07,7.88,21.34,14.61,26.5s38.46,4.05,42.05,0-3.43-26.79-8.53-30.27-8.73-.1-23.08-1.69C377.05,384.1,373.27,391.93,373.27,391.93Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s3.12,8.41,4.75,9.7,36.16,1.29,40-1.83-1.42-8.76-5.11-9.06C429.93,427.6,405.74,430.42,390.3,428.79Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.4000000059604645,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427l-6.69,1.34s-6.38,4.9-3.56,6.53S379,432.5,379.16,427Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.1c2fb06bf9dd52084732f9346b1137d8.svg";
export { ForwardRef as ReactComponent };